export const PRIVACY_POLICY_URL = 'https://goodstack.org/legal/privacy-policy'
export const TERMS_URL = 'https://goodstack.org/legal/applicant-validation-terms'
